export interface IHttpErrorLike {
  response?: {
    status?: number;
    data?: unknown;
  };
}

export { toError } from '~utils/toError';

export const getHttpResponse = (error: unknown): IHttpErrorLike['response'] => (
  typeof error === 'object' && error !== null ? (error as IHttpErrorLike).response : undefined
);
